import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 612960 690023"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:10000.3}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275342928">
        <path
          d="M607960 50352c0 25050-20311 45371-45352 45371-25050 0-45351-20301-45351-45371 0-25041 20301-45352 45351-45352 25041 0 45352 20291 45352 45352zM437204 50352c0 25050-20310 45371-45351 45371-25051 0-45382-20301-45382-45371 0-25041 20311-45352 45382-45352 25061 0 45351 20291 45351 45352z"
          className="fill stroke1"
          style={{
            strokeWidth: 10000.3,
          }}
        />
      </g>
      <g id="_1970275342704">
        <path
          d="M607960 197676c0 25041-20311 45372-45352 45372-25050 0-45351-20311-45351-45372 0-25070 20301-45351 45351-45351 25041 0 45352 20301 45352 45351zM437204 197676c0 25041-20310 45372-45351 45372-25051 0-45382-20311-45382-45372 0-25070 20311-45351 45382-45351 25061 0 45351 20301 45351 45351zM266469 197676c0 25041-20311 45372-45362 45372-25041 0-45351-20311-45351-45372 0-25070 20310-45351 45351-45351 25051 0 45362 20301 45362 45351z"
                    className="fill stroke1"
          style={{
            strokeWidth: 10000.3,
          }}

        />
      </g>
      <g id="_1970275344560">
        <path
          d="M607960 344991c0 25061-20311 45372-45352 45372-25050 0-45351-20311-45351-45372 0-25051 20301-45371 45351-45371 25041 20 45352 20330 45352 45371zM437204 344991c0 25061-20310 45372-45351 45372-25051 0-45382-20311-45382-45372 0-25051 20311-45371 45382-45371 25061 0 45351 20330 45351 45371zM266469 344991c0 25061-20311 45372-45362 45372-25041 0-45351-20311-45351-45372 0-25051 20310-45371 45351-45371 25051 20 45362 20330 45362 45371zM95723 344991c0 25061-20301 45372-45351 45372-25061 0-45372-20311-45372-45372 0-25051 20311-45371 45372-45371 25040 20 45351 20330 45351 45371z"
                    className="fill stroke1"
          style={{
            strokeWidth: 10000.3,
          }}

        />
      </g>
      <g id="_1970275344464">
        <path
          d="M607960 492336c0 25041-20311 45372-45352 45372-25050 0-45351-20311-45351-45372 0-25051 20301-45361 45351-45361 25041-20 45352 20290 45352 45361zM437204 492336c0 25041-20310 45372-45351 45372-25051 0-45382-20311-45382-45372 0-25051 20311-45361 45382-45361 25061 0 45351 20290 45351 45361zM266469 492336c0 25041-20311 45372-45362 45372-25041 0-45351-20311-45351-45372 0-25051 20310-45361 45351-45361 25051-20 45362 20290 45362 45361z"
                    className="fill stroke1"
          style={{
            strokeWidth: 10000.3,
          }}

        />
      </g>
      <g id="_1970275348016">
        <path
          d="M607960 639651c0 25041-20311 45371-45352 45371-25050 0-45351-20310-45351-45371 0-25071 20301-45352 45351-45352 25041-20 45352 20281 45352 45352zM437204 639651c0 25041-20310 45371-45351 45371-25051 0-45382-20310-45382-45371 0-25071 20311-45352 45382-45352 25061 0 45351 20281 45351 45352z"
                    className="fill stroke1"
          style={{
            strokeWidth: 10000.3,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
